import Vue from 'vue'
import Router from 'vue-router'

import { RouterMap } from './routes'

Vue.use(Router)

const router = new Router({
  routes: RouterMap
})

export default router
